import React, { useEffect, useState } from 'react';
import { Button } from '../button/button';
import { Modal } from '../modal/modal';
import { useAuthState } from '../../utilities/contexts/auth-state-context';
import HubspotSubCancellationDataService from '../../utilities/services/hubspot-sub-cancellation-data-service';
import { HubspotSubCancellationData } from '../../models/interfaces/hubspot-sub-cancellation-data';
import { enqueueSnackbar } from 'notistack';
// @ts-ignore
import HubspotForm from "react-hubspot-form";
import { TextTypeInput } from '../forms';
import { useForm } from 'react-hook-form';
import RadioTypeInput from '../forms/radio-type-input/radio-type-input';
import { useTranslation } from 'react-i18next';
import getFirebase from '../../utilities/firebase';
interface SubscriptionFeedbackDialogBoxProps {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  isLoading?: boolean;
  cancelButtonAction?: Function;
}

const COMPONENT_CLASS = "c-cancellation-dialog-box";
const { auth } = getFirebase();

const TrialUpgradeFeedbackDialogBox: React.FC<SubscriptionFeedbackDialogBoxProps> = (props) => {
  const {
    isOpen,
    onClose,
    title,
    isLoading,
    cancelButtonAction
  } = props;

  const methods = useForm<any>();

  const {
    register,
  } = methods;
  const { state, setState } = useAuthState();
  const [openPlanCancellationAgreement, setOpenPlanCancellationAgreement] = useState(false);
  const [selectedReason, setSelectedReason] = useState<number | null>(null);
  const [details, setDetails] = useState('');
  const [openHubspotForm, setOpenHubspotForm] = useState(false);
  const { t } = useTranslation();

  const reasons = [
    { value: t('cancellationDialogBox.reasons.tool'), text: t('cancellationDialogBox.reasons.tool_desc'), placeholder: t('cancellationDialogBox.reasons.tool_placeholder') },
    { value: t('cancellationDialogBox.reasons.features'), text: t('cancellationDialogBox.reasons.features_desc'), placeholder: t('cancellationDialogBox.reasons.features_placeholder') },
    { value: t('cancellationDialogBox.reasons.price'), text: t('cancellationDialogBox.reasons.price_desc'), placeholder: t('cancellationDialogBox.reasons.price_placeholder') },
    { value: t('cancellationDialogBox.reasons.other'), text: t('cancellationDialogBox.reasons.other_desc'), placeholder: t('cancellationDialogBox.reasons.other_placeholder') }];


  const handleRadioChange = (reason: number) => {
    setSelectedReason((prev) => prev === reason ? null : reason);
  };

  // Modal closes - reset everything;
  useEffect(() => {
    if (!openPlanCancellationAgreement || !isOpen) {
      setSelectedReason(null);
      setDetails('');
      setOpenHubspotForm(false);
    }
  }, [openPlanCancellationAgreement, isOpen]);

  const buttonOpenCancellationAgreement = (
    <Button
      type="default"
      buttonText={t('buttons.btn_cancelSubscription')}
      onClick={async () => {
        if (state.user) {
          try {
            const hubspotSubCanellationData: HubspotSubCancellationData = {
              organizationName: state.organization.name,
              accountHolderEmail: state.user?.email,
              accountHolderName: `${(state.user?.firstName || "")} ${(state.user?.lastName || "")}`,
              response: selectedReason !== null ? reasons[selectedReason].value : undefined,
              details: details || undefined,
            }

            await HubspotSubCancellationDataService.add(hubspotSubCanellationData, state.user);
            !cancelButtonAction && enqueueSnackbar(t('trialUpgradeFeedbackDialogBox.feedbackSent'), { variant: "toast", width: "450px" });
          } catch (err: any) {
            enqueueSnackbar(err);
          }

          setOpenPlanCancellationAgreement(false);
          onClose(false);
          auth.signOut();
          setState((state) => ({ ...state, ...{ authenticated: false, user: null } }));
        }
      }} />
  );

  return (
    <Modal
      isOpen={isOpen}
      isLoading={isLoading || false}
      onClose={onClose}
      title={title}
    >
      <div className={COMPONENT_CLASS}>
        <div className="my-8">{t('trialUpgradeFeedbackDialogBox.subTitle')}</div>
        <div className={`${COMPONENT_CLASS}__reasons`}>
          {reasons.map((reason, index) => (
            index === 2 ? (

              <div key={index}>
                <div className={`reason ${selectedReason === index ? 'visible' : ''}`} onClick={() => handleRadioChange(index)} >
                  <div>
                    <RadioTypeInput
                      id={`upgradeFeedbackReason-${index}`}
                      name="upgradeFeedbackReason"
                      checked={selectedReason === index}
                    />
                  </div>
                  <label>{reason.value}</label>
                </div>
                <div className={`cancellation-details ${selectedReason === index ? 'visible' : ''}`}>
                  <p style={{
                    fontSize: '14px', fontWeight: 'bold',
                  }}>{reason.text}</p>
                  <div className={'contact-us'}>
                    <Button
                      type="default"
                      buttonText="Contact Us"
                      onClick={() => setOpenHubspotForm(!openHubspotForm)} />
                    <div className='cancellation-button-white'>
                      {buttonOpenCancellationAgreement}
                    </div>
                    {openHubspotForm &&
                      <div className={`${COMPONENT_CLASS}__hubspot-form`}>
                        <HubspotForm
                          portalId='5419630'
                          formId='6dc531b3-6919-46fe-982b-af93fa7a0a04'
                          onFormSubmitted={() => {
                            enqueueSnackbar(t('trialUpgradeFeedbackDialogBox.inquiry'), { variant: "toast", width: "550px" });
                            setOpenHubspotForm(false);
                            setOpenPlanCancellationAgreement(false);
                            onClose(false);
                          }}
                          loading={<div>Loading...</div>}
                        />
                      </div>
                    }
                  </div>

                </div>
              </div>
            ) : (<div key={index}>
              <div className={`reason ${selectedReason === index ? 'visible' : ''}`} onClick={() => handleRadioChange(index)} >
                <div>
                  <RadioTypeInput
                    id={`upgradeFeedbackReason-${index}`}
                    name="upgradeFeedbackReason"
                    checked={selectedReason === index}
                  />
                </div>
                <label>{reason.value}</label>
              </div>
              <div className={`cancellation-details ${selectedReason === index ? 'visible' : ''}`}>
                <p style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>{reason.text}</p>
                {/* TODO: this input field onChange doesn't work with our TextInput, we need to fix this and swap to TextTypeInput */}
                <TextTypeInput
                  id='test'
                  type='text'
                  label={reason.placeholder}
                  hideLabel={true}
                  className='w-full'
                  registerHook={register}
                  registerOptions={{
                    value: details,
                    onChange: event => { setDetails(event.target.value) },
                  }} />
                <div className='cancellation-button'>
                  {buttonOpenCancellationAgreement}
                </div>
              </div>
            </div>)
          ))}
        </div>
      </div>
    </Modal>
  );

};

export default TrialUpgradeFeedbackDialogBox;